import { useEffect, useEffectEvent, useRef, useState } from "react";

export interface UseLoadMoreAnnouncementOptions {
    isFetchingNextPage: boolean;
    lastPageItemCount: number | undefined;
    getMessage: (count: number) => string;
}

export function useLoadMoreAnnouncement({ isFetchingNextPage, lastPageItemCount, getMessage }: UseLoadMoreAnnouncementOptions) {
    const wasFetchingNextPageRef = useRef<boolean>(false);
    const [announcement, setAnnouncement] = useState<string>("");

    const announceLoadedMore = useEffectEvent(() => {
        const newCount = lastPageItemCount ?? 0;

        if (newCount > 0) {
            setAnnouncement(getMessage(newCount));
        }
    });

    useEffect(() => {
        if (wasFetchingNextPageRef.current && !isFetchingNextPage) {
            announceLoadedMore();
            const timer = setTimeout(() => setAnnouncement(""), 1000);
            wasFetchingNextPageRef.current = isFetchingNextPage;

            return () => clearTimeout(timer);
        }

        wasFetchingNextPageRef.current = isFetchingNextPage;
    }, [isFetchingNextPage]);

    return announcement;
}
